module.exports = __webpack_public_path__ + "img/24.51588f4a.png";